import { Text, Anchor, Group } from "@mantine/core"
import { IconExternalLink } from "@tabler/icons-react"

import {
  BQ_ERROR_CODES,
  BQErrorCode,
} from "@costory/types/endpoints/billingDatasources"

import { getBqErrorMessage } from "@costory/front/utils/getBqTablePathValidation"

interface BigQueryErrorDisplayProps {
  errorCode?: BQErrorCode
  tablePath?: string
}

export const BigQueryErrorDisplay = ({
  errorCode,
  tablePath,
}: BigQueryErrorDisplayProps) => {
  // Special handling for replication error to render as a clickable link
  if (errorCode === BQ_ERROR_CODES.REPLICATION_NOT_ENABLED) {
    return (
      <Text c="red" ta="center">
        Costory currently does not support non EU location for your billing data
        stored in BigQuery: Could you enable the dataset replication in EU as
        explained in the docs (
        <Anchor
          href="https://help.costory.io/en/articles/10982158-set-up-documentation-google-cloud-platform-x-costory#h_7521f764f2"
          target="_blank"
          underline="hover"
          c="red"
        >
          <Group gap={4} display="inline-flex" align="center">
            <Text span>dataset replication</Text>
            <IconExternalLink size={14} />
          </Group>
        </Anchor>
        ).
      </Text>
    )
  }

  return (
    <Text c="red" ta="center">
      {getBqErrorMessage(errorCode, tablePath)}
    </Text>
  )
}
